import html from "html-literal";

export default state => html`

<div class="titleSettings">
          <h1 class="mainTitle">${state.header}</h1>
        </div>
`;
